import React from "react";
import "../../../styles/home1.css";

const newVendorsData = [
  { name: "Gold and Marry", sub: "637 Points - 98% Correct", value: 320, trend: "up" },
  { name: "Aditya Birla", sub: "637 Points - 89% Correct", value: 12, trend: "down" },
  { name: "Vedica Store", sub: "637 Points - 88% Correct", value: 546, trend: "up" }
];

export default function NewVendors() {
  return (
    <div className="card shadow-sm border-0 h-100">
      <div className="card-body">

        <div className="d-flex justify-content-between align-items-center mb-4">
          <h6 className="card-title fw-bold mb-0">New Vendors</h6>

          <button
            className="btn btn-sm btn-light text-primary fw-bold"
            style={{ fontSize: "0.8rem" }}
          >
            View All
          </button>
        </div>

        <div className="d-flex flex-column gap-3">

          {newVendorsData.map((vendor, index) => (
            <div
              key={index}
              className="d-flex align-items-center justify-content-between"
            >

              <div className="d-flex align-items-center gap-3">

                <div
                  className="rounded-circle bg-light d-flex align-items-center justify-content-center"
                  style={{ width: 40, height: 40 }}
                >
                  <span className="fw-bold text-secondary">
                    {vendor.name.charAt(0)}
                  </span>
                </div>

                <div>
                  <h6 className="mb-0 fw-bold" style={{ fontSize: "0.9rem" }}>
                    {vendor.name}
                  </h6>

                  <small
                    className="text-muted"
                    style={{ fontSize: "0.75rem" }}
                  >
                    {vendor.sub}
                  </small>
                </div>

              </div>

              <div className="text-end">
                <h6 className="mb-0 fw-bold">{vendor.value}</h6>

                <small
                  className={
                    vendor.trend === "up"
                      ? "text-success"
                      : "text-danger"
                  }
                >
                  {vendor.trend === "up" ? "▲" : "▼"}
                </small>
              </div>

            </div>
          ))}

        </div>

      </div>
    </div>
  );
}